import { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import ClimNavbar from "@/components/clim/ClimNavbar";
import ClimHero from "@/components/clim/ClimHero";
import ClimMarquee from "@/components/clim/ClimMarquee";
import ClimBenefits from "@/components/clim/ClimBenefits";
import ClimSimulator from "@/components/clim/ClimSimulator";
import ClimGallery from "@/components/clim/ClimGallery";
import ClimProcess from "@/components/clim/ClimProcess";
import ClimFaq from "@/components/clim/ClimFaq";
import ClimFooter from "@/components/clim/ClimFooter";
import ClimStickyBar from "@/components/clim/ClimStickyBar";
import Reviews from "@/components/Reviews";
import Zones from "@/components/Zones";
import { initPixel } from "@/lib/metaPixel";
import { getVariant, VARIANTS } from "@/lib/climVariants";
import ChatWidget from "@/components/ChatWidget";

export default function Climatisation() {
  const [params] = useSearchParams();
  const key = params.get("v");
  const [dynamic, setDynamic] = useState(null);

  useEffect(() => {
    if (!key || VARIANTS[key]) return;
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/variants?product=clim`)
      .then(({ data }) => {
        const d = (data.variants || []).find((v) => v.key === key);
        if (d)
          setDynamic({
            key: d.key,
            label: d.label,
            lines: d.lines.map((text, i) => ({ text, accent: i === d.lines.length - 1 })),
            sub: d.sub,
            image: `/${d.image}.webp`,
            alt: "Climatisation Daikin installée par Ener Solutions",
            widget: { value: d.widget_value, caption: d.widget_caption },
          });
      })
      .catch(() => {});
  }, [key]);

  const variant = dynamic || getVariant(key);

  useEffect(() => {
    document.title = "Climatisation Daikin en Gironde — dès 2 500 € posé | Ener Solutions";
    initPixel();
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="clim-page" className="bg-glacier font-sans text-ink antialiased">
      <ClimNavbar />
      <main className="relative">
        <ClimHero variant={variant} />
        <ClimMarquee />
        <ClimBenefits />
        <ClimSimulator variant={variant.key} />
        <ClimGallery />
        <ClimProcess />
        <Reviews variant="light" />
        <Zones />
        <ClimFaq />
        <ClimFooter />
      </main>
      <ClimStickyBar />
      <ChatWidget product="clim" theme="light" />
    </div>
  );
}
